import BarceloComponents from "barcelo-components-init";
import BwdComponents from "bwd-components";

document.addEventListener("DOMContentLoaded", () => {
  const options = Object.assign({ root: document, forceImport: false }, { debugLabel: "BWD" });

  BarceloComponents.init(BwdComponents, options);
});
